import { Tooltip, TooltipContent, TooltipTrigger } from "@repo/ui/tooltip";
import type { ReactNode } from "react";

/**
 * Wraps children in a tooltip explaining why saving is disabled.
 * Renders children as-is when the save action is available.
 */
export const DatasetSaveTooltip = ({
  hasPendingChanges,
  isSaving,
  children,
  side,
  sideOffset,
}: {
  hasPendingChanges: boolean;
  isSaving: boolean;
  children: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  sideOffset?: number;
}) => {
  const disabledReason = isSaving
    ? "Save in progress"
    : !hasPendingChanges
      ? "No unsaved changes"
      : null;

  if (!disabledReason) return children;

  return (
    <Tooltip>
      <TooltipTrigger render={<span className="flex" />}>
        {children}
      </TooltipTrigger>
      <TooltipContent side={side} sideOffset={sideOffset}>
        {disabledReason}
      </TooltipContent>
    </Tooltip>
  );
};
